<template>
  <div class="criteria">
    <div class="criteria__title">
      {{ $t('reset-password.elements') }}
    </div>
    <div class="criteria__criteria-cols">
      <div class="criteria-cols__col">
        <ul>
          <li v-bind:class="{ valid: passwordCriteria.lowercase }">
            <span>
              {{ $t('reset-password.lowercase') }}
            </span>
          </li>
          <li v-bind:class="{ valid: passwordCriteria.uppercase }">
            <span>
              {{ $t('reset-password.uppercase') }}
            </span>
          </li>
          <li v-bind:class="{ valid: passwordCriteria.special }">
            <span>
              {{ $t('reset-password.special') }}
            </span>
          </li>
        </ul>
      </div>
      <div class="criteria-cols__col">
        <ul>
          <li v-bind:class="{ valid: passwordCriteria.number }">
            <span>
              {{ $t('reset-password.number') }}
            </span>
          </li>
          <li v-bind:class="{ valid: passwordCriteria.length }">
            <span>
              {{ $t('reset-password.length') }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="criteria__alert" v-if="!isFormInvalid">
      <BaseIcon name="check-circle" class="alert__icon" />
      <span>{{ $t('reset-password.secure') }}</span>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import { validatePassword } from '@/util/password-util';

export default {
  name: 'PasswordCriteria',
  components: {
    BaseIcon,
  },
  props: {
    password: String,
  },
  computed: {
    isFormInvalid() {
      return !this.passwordCriteria.valid;
    },
    passwordCriteria() {
      return validatePassword(this.password);
    },
  },
};
</script>

<style lang="scss" scoped>
.criteria {
  border: $grey-border;
  width: 100%;
  font-size: $font-size-xsmall;
  padding: 1rem;
  position: relative;
  text-align: left;

  &__title {
    color: $color-normal-pale;
  }

  &__criteria-cols {
    display: flex;
    margin-top: 0.7rem;

    .criteria-cols__col {
      flex: 1 0 auto;
      height: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      color: $color-neutral;

      li {
        list-style-position: inside;
      }
    }
  }
  &__alert {
    position: absolute;
    color: $color-white;
    right: 1rem;
    bottom: -0.6rem;
    background-color: $color-success;
    border-radius: $border-radius-small;
    padding: 5px;
    display: flex;
    flex-direction: row;
  }
}
.alert__icon {
  width: 1rem;
  height: 1rem;
  margin-right: 0.3rem;
  margin-top: -0.1px;
}

ul {
  margin: 0;
  padding: 0;
}

li {
  list-style-position: inside;
  color: $color-normal;

  &.valid {
    color: $color-normal;
    opacity: 0.3;
  }

  &:not(:last-of-type) {
    margin-bottom: 0.5rem;
  }

  span {
    position: relative;
    left: -0.5rem;
  }
}

@media screen and (max-width: 468px) {
  .criteria {
    &__criteria-cols {
      display: block;

      .criteria-cols__col:nth-child(2) {
        padding-top: 8px;
      }
    }
  }
}
</style>
